export const STATUS_VALID = 'VALID';
export const STATUS_INVALID = 'INVALID';
export const STATUS_NOT_VERIFIED = 'NOT_VERIFIED';
